import { render, staticRenderFns } from "./VerProjeto.vue?vue&type=template&id=32e5f13f"
import script from "./VerProjeto.vue?vue&type=script&lang=ts"
export * from "./VerProjeto.vue?vue&type=script&lang=ts"
import style0 from "./VerProjeto.vue?vue&type=style&index=0&id=32e5f13f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports